import CopyButton from "./CopyButton";
import notificationStore from "~/stores/notifications";
import { Copy } from "lucide-react";
import { Document, documentCopyLink } from "~/document";
import { useCallback, useContext } from "react";
import { ToastNotificationContext } from "~/components/ToastNotificationContext";

const ShareDocumentButton = (props: { doc: Document; className?: string }) => {
  const { showNotificationWithTimeout, setNotificationData } = useContext(ToastNotificationContext);

  const onCopy = useCallback(() => {
    setNotificationData({
      kind: "success",
      title: "Success",
      subtitle: "Link copied to clipboard",
    });
    notificationStore.success("Successfully copied document URL to clipboard");
    showNotificationWithTimeout();
  }, []);

  return (
    <CopyButton
      copyContent={new URL(documentCopyLink(props.doc)).toString()}
      onCopy={onCopy}
      onFail={() => notificationStore.error("Failed to copy document URL to clipboard")}
      buttonProps={{ variant: "secondary", size: "sm", className: props.className }}
    >
      <Copy />
      Copy link
    </CopyButton>
  );
};

export default ShareDocumentButton;
